module.exports = __webpack_public_path__ + "img/signup-img.1cec0ad2.png";